var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "106",
      "height": "29",
      "viewBox": "0 0 106 29",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "clip-path": "url(#logoBold_svg__clip0_35_449)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#logoBold_svg__clip1_35_449)",
      "fill": "#FDF21A"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#logoBold_svg__clip2_35_449)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.633 13.892c2.574 1.25 4.19 3.755 4.19 6.81 0 4.537-3.82 7.973-8.862 7.973H0V.678h14.709c4.843 0 8.377 3.028 8.377 7.165 0 2.502-1.367 4.752-3.453 6.048zm-3.253 5.893c0-1.487-1.066-2.534-2.695-2.534h-6.46v5.091h6.46c1.63 0 2.695-1.046 2.695-2.557zm-.436-10.664c0-1.453-.97-2.437-2.544-2.437H7.226v4.874H13.4c1.574 0 2.545-.984 2.545-2.437z"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.32 21.612v7.063H57.196V.678h7.625v20.934h11.5z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M105.611 14.654c0 8.17-5.854 14.021-14.1 14.021H79.268V.678H91.51c8.27 0 14.101 5.795 14.101 13.976zm-7.715 0c0-4.154-2.696-6.912-6.74-6.912h-4.328v13.87h4.327c4.045 0 6.74-2.828 6.74-6.958z"
    }
  })]), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M39.517 0c-7.92 0-14.339 6.268-14.339 13.999 0 7.731 6.42 13.999 14.34 13.999 7.918 0 14.338-6.268 14.338-14C53.856 6.269 47.436 0 39.517 0zm0 20.983c-3.951 0-7.154-3.127-7.154-6.984 0-3.858 3.203-6.985 7.154-6.985s7.154 3.127 7.154 6.985c0 3.857-3.203 6.984-7.154 6.984z"
    }
  })])]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "logoBold_svg__clip0_35_449"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h105.61v28.675H0z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "logoBold_svg__clip1_35_449"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h105.61v28.675H0z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "logoBold_svg__clip2_35_449"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "transform": "translate(0 .678)",
      "d": "M0 0h105.61v27.997H0z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }